import * as React from 'react';
import * as Moment from 'moment-timezone';
import ActionButtonGroup from './ActionButtonGroup';

interface IAdjustDateButtonsProps {
  date: Date;
  tz: string;
  setDate: (newDate: Moment.Moment) => void;
}

export default class AdjustDateButtons extends React.Component<IAdjustDateButtonsProps> {

  constructor(props: IAdjustDateButtonsProps) {
    super(props);

    this.addDay = this.addDay.bind(this);
    this.subDay = this.subDay.bind(this);
    this.addWeek = this.addWeek.bind(this);
    this.subWeek = this.subWeek.bind(this);
    this.addMonth = this.addMonth.bind(this);
    this.subMonth = this.subMonth.bind(this);
    this.addHour = this.addHour.bind(this);
    this.subHour = this.subHour.bind(this);
  }

  public render() {
    return (
      <>
        <ActionButtonGroup
          title="Month"
          actions={[{
            title: "➕",
            action: this.addMonth
          },
          {
            title: "➖",
            action: this.subMonth
          }
          ]}
        />
        <ActionButtonGroup
          title="Week"
          actions={[{
            title: "➕",
            action: this.addWeek
          },
          {
            title: "➖",
            action: this.subWeek
          }
          ]}
        />
        <ActionButtonGroup
          title="Day"
          actions={[{
            title: "➕",
            action: this.addDay
          },
          {
            title: "➖",
            action: this.subDay
          }
          ]}
        />
        <ActionButtonGroup
          title="Hour"
          actions={[{
            title: "➕",
            action: this.addHour
          },
          {
            title: "➖",
            action: this.subHour
          }
          ]}
        />
      </>
    )
  }

  public addDay (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).add(1, 'day'));
  }

  public subDay (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).add(-1, 'day'));
  }

  public addWeek (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).add(1, 'week'));
  }

  public subWeek (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).add(-1, 'week'));
  }

  public addMonth (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).add(1, 'month'));
  }

  public subMonth (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).add(-1, 'month'));
  }

  public addHour (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).add(1, 'hour'));
  }

  public subHour (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).add(-1, 'hour'));
  }

}


// WEBPACK FOOTER //
// ./src/Calculator/AdjustDateButtons.tsx